import(/* webpackMode: "eager" */ "/codebuild/output/src2434895410/src/app/home/page.tsx");
